module.exports = __webpack_public_path__ + "static/img/100606.dd442ddc.png";